import "../styles/Footer.css";
import "../styles/Contact.css";
import profilePic from "../assets/profile.webp";

// Icons
import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import RedditIcon from "@mui/icons-material/Reddit";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";

const Contact = () => {
  return (
    <div>
      <div className="contact_container">
        <div className="contact_section">
          <div className="contact_head">
            <h2>contact</h2>
            <h1><span>let's</span></h1>
            <h1>talk</h1>
          </div>
          <div className="contact_form_box">
            <form action="">
              <label htmlFor="name">name</label>
              <input type="text" id="name" placeholder="Your Name" required/>
              <label htmlFor="email">email</label>
              <input type="email" id="email" placeholder="Your Email" required/>
              <label htmlFor="message">message</label>
              <textarea name="message" id="message" placeholder="Your Message" cols="30" rows="10"></textarea>
              <button type="submit">SEND MESSAGE</button>
            </form>
          </div>
        </div>

    {/* Footer */}

      <div className="footer_line"></div>
      <div className="footer">
        <div className="content1">
          <div className="contentContainer" style={{ padding: 0 }}>
            <img src={profilePic} alt="" className="profile" />
            <div className="profileData">
              <h1>Sasuke &nbsp;Yanai</h1>
              <p>VISUAL ART DIRECTOR</p>
            </div>
          </div>
          <div className="gap"></div>
          <div className="social">
            <div>
              <a href="https://www.instagram.com/akaclever_coder/" target="_blank" rel="noopener noreferrer">
                <InstagramIcon />
              </a>
            </div>
            <div>
              <a href="https://t.me/akaclevercoder" target="_blank" rel="noopener noreferrer">
                <TelegramIcon />
              </a>
            </div>
            <div>
              <a href="https://www.reddit.com/user/clever-coder?utm_source=share&utm_medium=android_app&utm_name=androidcss&utm_term=3&utm_content=share_button" target="_blank" rel="noopener noreferrer">
                <RedditIcon />
              </a>
            </div>
            <div>
              <a href="https://wa.me/917249084224" target="_blank" rel="noopener noreferrer">
                <WhatsAppIcon />
              </a>
            </div>
          </div>
        <div className="social">
            <div>
              <a href="https://twitter.com/CleverCoder0" target="_blank" rel="noopener noreferrer">
                <TwitterIcon />
              </a>
            </div>
            <div>
              <a href="https://www.linkedin.com/in/clever-coder/" target="_blank" rel="noopener noreferrer">
                <LinkedInIcon />
              </a>
            </div>
            <div>
              <a href="facebook.com/profile.php?id=100022096027053" target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
              </a>
            </div>
            <div>
              <a href="https://github.com/CleverCoder03" target="_blank" rel="noopener noreferrer">
                <GitHubIcon />
              </a>
          </div>
        </div>
        </div>
      </div>
      <p className="credit">Developed by Vishal Mishra &copy; 2023</p>
      <div className="footer_line"></div>
      </div>
    </div>
  )
}

export default Contact